import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { ImagePickerContext, } from './ImagePickerContext';
// Sets the display of its first children to prevent the undesired extra white space in the
// wrapping button caused by images or svgs
const buttonPadding = theme.spacing.base;
const buttonStyles = (selected) => css `
  ${styleUtils.buttonReset}
  position: relative;
  padding: ${buttonPadding};
  border: ${theme.spacing.base} solid ${selected ? theme.colors.gray700 : 'transparent'};

  &:hover,
  &:focus {
    cursor: pointer;
    border: ${theme.spacing.base} solid ${selected ? theme.colors.gray700 : theme.colors.gray400};
  }

  > img,
    svg {
    box-shadow: ${styleUtils.rem(1)} ${styleUtils.rem(1)} ${styleUtils.rem(5)} ${theme.colors.gray500};
    display: block;
    margin: auto;
  }
`;
const textLabelStyles = css `
  position: absolute;
  right: ${buttonPadding};
  bottom: ${buttonPadding};
  ${theme.typeStyles.bodySmallStyles}
  padding: ${theme.spacing.base};
  color: ${theme.colors.gray100};
  background-color: ${theme.colors.gray700};
`;
const defaultProps = {
    className: '',
    onClick: undefined,
    textLabel: '',
};
const ImagePickerOption = ({ className = defaultProps.className, content, onClick = defaultProps.onClick, selected, textLabel = defaultProps.textLabel, }) => (_jsx(ImagePickerContext.Consumer, { children: ({ multiSelect, }) => (_jsxs("button", Object.assign({ "aria-checked": selected, className: className, css: buttonStyles(selected), onClick: onClick, role: multiSelect ? 'checkbox' : 'radio', type: "button" }, { children: [content, textLabel && (_jsx("span", Object.assign({ css: textLabelStyles }, { children: textLabel })))] }))) }));
const MemoizedImagePickerOption = memo(ImagePickerOption);
export { MemoizedImagePickerOption as ImagePickerOption };
// MC-1068 Temporary hack for Storybook.
export default ImagePickerOption;
